import { SEO } from 'src/components/SEO'
import services from 'src/static/services'
import Service from '../../components/Service'
import { useRouter } from 'next/router'
import BASE_CONFIG from 'src/configs/base'

const Services = ({ data }) => {
	return (
		<div>
			<SEO
				data={{
					title: `Dịch vụ | ${data.text.title}`,
					description: data.text.seoDescription ? data.text.seoDescription : data.text.descript,
					keywords: `dịch vụ, ${data.text.title}`,
					// thumbnailUrl: 
					url: BASE_CONFIG.PAGE_URL+useRouter().asPath
				}}
			/>
			<Service data={data}></Service>
		</div>
	)
}

export default Services

export const getStaticProps = ({ params }) => {
	const { slug } = params
	const data = services.find((e) => e.slug === slug)

	return {
		props: {
			data,
		},
	}
}

export const getStaticPaths = () => {
	return {
		paths: services.map((e) => ({
			params: {
				slug: e.slug,
			},
		})),
		fallback: false,
	}
}
